<div if.bind="logs.panelOpen" class="modal-overlay" click.trigger="logs.closePanel()">
  <div class="logs-admin" click.trigger="$event.stopPropagation()">
    <div class="logs-admin__header">
      <h3 class="logs-admin__title">Latest log</h3>
      <button type="button" class="logs-admin__close" click.trigger="logs.closePanel()" aria-label="Close"><span class="icon icon--close" aria-hidden="true"></span></button>
    </div>

    <div class="logs-admin__body">
      <div class="logs-admin__toolbar">
        <div if.bind="logs.log && logs.log.fileName" class="logs-admin__meta">
          <span class="logs-admin__file">${logs.log.fileName}</span>
          <span class="logs-admin__sub">${logs.log.modifiedUtc} &middot; ${logs.log.sizeBytes} bytes</span>
          <span if.bind="logs.log.truncated" class="logs-admin__badge">Showing tail only</span>
        </div>
        <button type="button" class="login-btn login-btn--secondary" click.trigger="logs.load()" disabled.bind="logs.loading">Refresh</button>
      </div>

      <div if.bind="logs.error" class="logs-admin__error">${logs.error}</div>
      <div if.bind="logs.loading" class="logs-admin__status">Loading log&hellip;</div>

      <div if.bind="!logs.loading && (!logs.log || !logs.log.fileName) && !logs.error" class="logs-admin__status">
        No log files found under the logs folder.
      </div>

      <pre if.bind="!logs.loading && logs.log && logs.log.fileName" class="logs-admin__content">${logs.log.content}</pre>
    </div>
  </div>
</div>
